export const MGTextStyleDefinitions = {
  "body-300-06": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1.5rem",
    fontWeight: 700,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "body-300-05": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1.5rem",
    fontWeight: 600,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "body-300-04": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1.5rem",
    fontWeight: 500,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "body-300-03": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1.5rem",
    fontWeight: 400,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "body-200-06": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1.125rem",
    fontWeight: 700,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "body-200-05": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1.125rem",
    fontWeight: 600,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "body-200-04": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1.125rem",
    fontWeight: 500,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "body-200-03": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1.125rem",
    fontWeight: 400,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "body-100-06": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1rem",
    fontWeight: 700,
    lineHeight: 1.6,
    textTransform: "none",
  },
  "body-100-05": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1rem",
    fontWeight: 600,
    lineHeight: 1.6,
    textTransform: "none",
  },
  "body-100-04": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: 1.6,
    textTransform: "none",
  },
  "body-100-03": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: 1.6,
    textTransform: "none",
  },
} as const;

export type TMGTextStyleDefinitions = keyof typeof MGTextStyleDefinitions;

export const MGTitleStyleDefinitions = {
  "300-08": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "3rem",
    fontWeight: 900,
    lineHeight: 1.2,
    textTransform: "none",
  },
  "300-07": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "3rem",
    fontWeight: 800,
    lineHeight: 1.2,
    textTransform: "none",
  },
  "300-06": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "3rem",
    fontWeight: 700,
    lineHeight: 1.2,
    textTransform: "none",
  },
  "200-08": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "2.5rem",
    fontWeight: 900,
    lineHeight: 1.2,
    textTransform: "none",
  },
  "200-07": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "2.5rem",
    fontWeight: 800,
    lineHeight: 1.2,
    textTransform: "none",
  },
  "200-06": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "2.5rem",
    fontWeight: 700,
    lineHeight: 1.2,
    textTransform: "none",
  },
  "100-08": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "2rem",
    fontWeight: 900,
    lineHeight: 1.2,
    textTransform: "none",
  },
  "100-07": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "2rem",
    fontWeight: 800,
    lineHeight: 1.2,
    textTransform: "none",
  },
  "100-06": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "2rem",
    fontWeight: 700,
    lineHeight: 1.2,
    textTransform: "none",
  },
  "80-08": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "1.5rem",
    fontWeight: 900,
    lineHeight: 1.35,
    textTransform: "none",
  },
  "80-07": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "1.5rem",
    fontWeight: 800,
    lineHeight: 1.35,
    textTransform: "none",
  },
  "80-06": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "1.5rem",
    fontWeight: 700,
    lineHeight: 1.35,
    textTransform: "none",
  },
} as const;

export type TMGTitleStyleDefinitions = keyof typeof MGTitleStyleDefinitions;

export const MGSubtitleStyleDefinitions = {
  "200-08": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "1.25rem",
    fontWeight: 900,
    lineHeight: 1.35,
    textTransform: "none",
  },
  "200-07": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "1.25rem",
    fontWeight: 800,
    lineHeight: 1.35,
    textTransform: "none",
  },
  "200-06": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "1.25rem",
    fontWeight: 700,
    lineHeight: 1.35,
    textTransform: "none",
  },
  "100-08": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "1rem",
    fontWeight: 900,
    lineHeight: 1.45,
    textTransform: "none",
  },
  "100-07": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "1rem",
    fontWeight: 800,
    lineHeight: 1.45,
    textTransform: "none",
  },
  "100-06": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "1rem",
    fontWeight: 700,
    lineHeight: 1.45,
    textTransform: "none",
  },
  "50-08": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "0.75rem",
    fontWeight: 900,
    lineHeight: 1.45,
    textTransform: "uppercase",
  },
  "50-07": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "0.75rem",
    fontWeight: 800,
    lineHeight: 1.45,
    textTransform: "uppercase",
  },
  "50-06": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "0.75rem",
    fontWeight: 700,
    lineHeight: 1.45,
    textTransform: "uppercase",
  },
} as const;

export type TMGSubtitleStyleDefinitions = keyof typeof MGSubtitleStyleDefinitions;

export const MGMicrotextStyleDefinitions = {
  "microcopy-100-06": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.875rem",
    fontWeight: 700,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "microcopy-100-05": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.875rem",
    fontWeight: 600,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "microcopy-100-04": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "microcopy-100-03": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "microcopy-80-06": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.75rem",
    fontWeight: 700,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "microcopy-80-05": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.75rem",
    fontWeight: 600,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "microcopy-80-04": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.75rem",
    fontWeight: 500,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "microcopy-80-03": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: 1.7,
    textTransform: "none",
  },
  "microcopy-60-07": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.625rem",
    fontWeight: 700,
    lineHeight: 1.8,
    textTransform: "uppercase",
  },
  "microcopy-60-06": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.625rem",
    fontWeight: 700,
    lineHeight: 1.8,
    textTransform: "none",
  },
  "microcopy-60-05": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.625rem",
    fontWeight: 600,
    lineHeight: 1.8,
    textTransform: "none",
  },
  "microcopy-60-04": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.625rem",
    fontWeight: 500,
    lineHeight: 1.8,
    textTransform: "none",
  },
  "microcopy-60-03": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.625rem",
    fontWeight: 400,
    lineHeight: 1.8,
    textTransform: "none",
  },
} as const;

export type TMGMicrotextStyleDefinitions = keyof typeof MGMicrotextStyleDefinitions;

export const MGLabelStyleDefinitions = {
  "700-02": {
    fontFamily: '"MG Lato", Lato, sans-serif',
    fontSize: "3rem",
    fontWeight: 300,
    lineHeight: 1.2,
    textTransform: "none",
  },
  "500-06": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "2rem",
    fontWeight: 700,
    lineHeight: 1.4,
    textTransform: "none",
  },
  "400-06": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1.5rem",
    fontWeight: 700,
    lineHeight: 1.4,
    textTransform: "none",
  },
  "300-04": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1.25rem",
    fontWeight: 700,
    lineHeight: 1.4,
    textTransform: "none",
  },
  "300-03": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1.25rem",
    fontWeight: 400,
    lineHeight: 1.4,
    textTransform: "none",
  },
  "100-06": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1rem",
    fontWeight: 700,
    lineHeight: 1.4,
    textTransform: "none",
  },
  "100-05": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1rem",
    fontWeight: 600,
    lineHeight: 1.4,
    textTransform: "none",
  },
  "100-04": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: 1.4,
    textTransform: "none",
  },
  "80-06": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.875rem",
    fontWeight: 700,
    lineHeight: 1.4,
    textTransform: "none",
  },
  "80-05": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.875rem",
    fontWeight: 600,
    lineHeight: 1.4,
    textTransform: "none",
  },
  "80-03": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.4,
    textTransform: "none",
  },
  "60-03": {
    fontFamily: '"MG Open Sans", "Open Sans", sans-serif',
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: 1.4,
    textTransform: "none",
  },
} as const;

export type TMGLabelStyleDefinitions = keyof typeof MGLabelStyleDefinitions;
